import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateOccupation } from '../../../../actions/occupationAction';
import moment from 'moment';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import OccupationFields from '../../../../components/Fields/OccupationFields';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import {OCCUPATION} from '../../../../utils/FieldTypes';

class InlineEditOccupation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  handleChange(event) {
    this.props.handleChange(OCCUPATION, event);
  }
  validateField(event) {
    this.props.validateField(OCCUPATION, event);
  }
  onClickSave(event) {
    event.preventDefault();
    let validateFields = (this.props.status === "Employed" || this.props.status === "SelfEmployed") ? ["status", "occupationName", "industry", "employer", "employedSince", "phone"] : ["status"];

    this.props.validateFields(OCCUPATION, validateFields, (isValid) => {
      if(isValid) {
        if(this.props.status !== "Employed" && this.props.status !== "SelfEmployed") {
          this.props.updateOccupation({status: this.props.status, occupationName: "", industry: "", noc: this.props.noc, employer: "", employedSince: "", phone: ""});
        }
        else {
          this.props.updateOccupation({status: this.props.status, occupationName: this.props.occupationName, industry: this.props.industry, noc: this.props.noc, employer: this.props.employer, employedSince: this.props.employedSince, phone: this.props.phone});
        }
        this.toggleEdit();
      }
      else {
        this.setState({
          saveDialogOpen: false
        })
      }
    });  
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(OCCUPATION);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }
  cancelEdit() {
    if( this.props.status === this.props.savedOccupation.status &&
        this.props.occupationName === this.props.savedOccupation.occupationName &&
        this.props.industry === this.props.savedOccupation.industry &&
        this.props.employer === this.props.savedOccupation.employer &&
        this.props.employedSince === this.props.savedOccupation.employedSince &&
        this.props.phone === this.props.savedOccupation.phone) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }
  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    let employerLabel = "Employer";
    if(this.props.savedOccupation.status === "SelfEmployed") {
      employerLabel = "Company Name"
    }    
    let formattedDate = "";

    if(this.props.savedOccupation.employedSince !== undefined) {
      formattedDate = moment(this.props.savedOccupation.employedSince).format("MMM YYYY");
    }    

    let fragment;
    console.log(this.props.savedOccupation.phone)
    var hasPhone = this.props.savedOccupation.phone.length > 0 ? true : false;

    if(hasPhone) {
      fragment = <StaticField label="Phone" value={this.props.savedOccupation.phone} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} /> 
    }

    let extraStaticFields;
    if(this.props.savedOccupation.status === "Employed" || this.props.savedOccupation.status === "SelfEmployed") {
      extraStaticFields = (
        <div>
          <StaticField label="Industry" value={this.props.savedOccupation.industry} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
          <StaticField label="Occupation" value={this.props.savedOccupation.occupationName} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
          <StaticField label={employerLabel} value={this.props.savedOccupation.employer} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
          <StaticField label="Employed Since" value={formattedDate} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
          { fragment }
        </div>);
    }

    let occupationStatusLabel = this.props.savedOccupation.status;

    if(this.props.savedOccupation.status === "SelfEmployed") {
      occupationStatusLabel = "Self-Employed";
    }
    else if(this.props.savedOccupation.status === "SocialAssit") {
      occupationStatusLabel = "On disability assistance";
    }

    return (
      <div className="review-inline-edit">
        {!this.state.edit ? 
          <div>
            <StaticField label="Occupation Status" value={occupationStatusLabel} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
            {extraStaticFields}
          </div>
        :
          <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>            
            <OccupationFields {...this.props} handleChange={this.handleChange} validateField={this.validateField}  />
          </InlineEdit>
        }
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Occupation" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}

const mapStateToProps = state => ({
  //...state.occupation
})

const mapDispatchToProps = dispatch => ({
  updateOccupation: (occupationInfo) => dispatch(updateOccupation(occupationInfo))
})

export default connect(mapStateToProps, mapDispatchToProps)(InlineEditOccupation);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/Occupation/Occupation.js